exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg[data-v-1d8c027e]{width:var(--size);height:var(--size)}path[data-v-1d8c027e]{fill:currentColor}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d8c027e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vuejs/frontend/2023-launch/components/AppIconBase.vue
// module id = BhkK
// module chunks = 4